import LocaleSelector from './locale_selector';

export default LocaleSelector;
